import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Icon from '~/components/Icon';
import * as S from './styles';

export default function Download({
  text,
  disabled,
  loading,
  competition,
  ...rest
}) {
  const { t } = useTranslation();
  return (
    <S.Download disabled={disabled} competition={competition} {...rest}>
      <div>{disabled ? t('documentUnavailable') : text}</div>
      <div>
        {loading ? (
          <S.Spinner size={32} />
        ) : (
          <Icon size={18} name="download" color={disabled ? 'dark' : 'white'} />
        )}
      </div>
    </S.Download>
  );
}

Download.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  competition: PropTypes.number,
};

Download.defaultProps = {
  text: null,
  disabled: false,
  loading: false,
  competition: 1,
};
